export const initManufacturingMaterial = (material = {}) => ({
    ...material,

    name: material?.name || null,
    code: material?.code || null,
    price: material?.price || 0,
    stock: material?.stock || 0,
    maker: material?.maker || null,
});
